/**
 * @file: 横杆挂钉标签渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

interface HangnailDetail {
    backSpace: number,
    backYspace: number
    hangnailDetail: string,
    hangnailLength: number,
    hangnailNum: number,
    hangnailType: number,
    holeNum: number,
    labelHeight: number,
    labelWidth: number,
    labelXspace: number,
    labelYspace: number,
    slopeHeight: number
}

export function renderBeamTag(cube: CubeNode): void {
    if (renderDisable(cube)) {
        return;
    }
    let nailData: HangnailDetail = FrontCubeData.getValue(cube.id, 'hangnailDetail');
    let $box: JQuery = cube.jView.find('.default-attr-box');
    let $nailLabel: JQuery = createLabel(nailData);

    Toolkit.html($box, '');
    $box.append($nailLabel);
}

function createLabel(nailData: HangnailDetail): JQuery {
    let $result = $(document.createElement('div')).addClass('nail-label');

    $result.css({
        width: Toolkit.cmToPx(Utils.toNumber(nailData.labelWidth)),
        height: Toolkit.cmToPx(Utils.toNumber(nailData.labelHeight)),
        top: -Toolkit.cmToPx(Utils.toNumber(nailData.labelYspace)),
        left: Toolkit.cmToPx(Utils.toNumber(nailData.labelXspace))
    });
    return $result;
}

function renderDisable(cube: CubeNode): boolean {
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(cube.id);
    let nailId: number = UIToolkit.getCubeNumberValue(cube.id, 'hangnailId');
    let nailData: HangnailDetail = FrontCubeData.getValue(cube.id, 'hangnailDetail');

    return !nailId || !nailData || !CubeTree.isBeam(parentCube.id);
}
